import React, { Component } from 'react';
import styled, { css } from 'styled-components'
import { PageContainer, Header, PageTitle, TextBox, TextBlock, BottomButtons, Button } from '../components/styledComponents'

const ButtonHolder = styled(BottomButtons)`
  align-items: center;
  justify-content: center;
  bottom: 140px;
`

const RecordButton = styled(Button)`
	width: 96px;
  height: 96px;
	background: #930c0c;
  border-radius: 50%;
  background-image: url(mic.svg);
  background-size: 75%;
  background-repeat: no-repeat;
  background-position: center;
  line-height: 200px;
  color: #930c0c;

  ${props => props.state && css`
  	background-image: url(stop.svg);
  	background-size: 45%;
  `}
`

export default class Respond extends Component {
	state = {
		running: false
	}

	startRecording() {
		if (!this.state.running) {
			this.setState({ running: true })
		} else {
			this.stopRecording()
		}
	}

	stopRecording() {
		this.setState({ running: false })
		this.props.onProceed()
	}

	render() {
		const { running } = this.state
		return (
			<PageContainer>
				<TextBlock style={{ marginTop: '40px' }}>
					<p>Record what came to your mind during the meditation by clicking the button below when you're ready</p>
					<p>Be honest, it's totally private</p>
				</TextBlock>
				<ButtonHolder>
					<RecordButton
						onClick={this.startRecording.bind(this)}
						state={running}
					>
						{!running ? 'Record' : 'Stop'}
					</RecordButton>
				</ButtonHolder>
			</PageContainer>
		)
	}

}
